/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UpdateLineActivationProviderSettingInput = {
  liffId?: string | null | undefined;
  lineChannelId?: string | null | undefined;
  lineFollowUrl?: string | null | undefined;
  messageApiAccessToken: string;
  messageApiChannelSecret: string;
};

export type LineActivationProviderSettingEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LineActivationProviderSettingEditPageQuery = { lineActivationProviderSetting: { messageApiAccessToken: string, messageApiChannelSecret: string, lineChannelId: string | null, liffId: string | null, lineFollowUrl: string | null } | null };

export type UpdateLineActivationProviderSettingMutationVariables = Exact<{
  input: Types.UpdateLineActivationProviderSettingInput;
}>;


export type UpdateLineActivationProviderSettingMutation = { updateLineActivationProviderSetting: { messageApiAccessToken: string, messageApiChannelSecret: string, lineChannelId: string | null, liffId: string | null, lineFollowUrl: string | null } };


export const LineActivationProviderSettingEditPageDocument = gql`
    query LineActivationProviderSettingEditPage {
  lineActivationProviderSetting {
    messageApiAccessToken
    messageApiChannelSecret
    lineChannelId
    liffId
    lineFollowUrl
  }
}
    `;

/**
 * __useLineActivationProviderSettingEditPageQuery__
 *
 * To run a query within a Vue component, call `useLineActivationProviderSettingEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineActivationProviderSettingEditPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineActivationProviderSettingEditPageQuery();
 */
export function useLineActivationProviderSettingEditPageQuery(options: VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>(LineActivationProviderSettingEditPageDocument, {}, options);
}
export function useLineActivationProviderSettingEditPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>(LineActivationProviderSettingEditPageDocument, {}, options);
}
export type LineActivationProviderSettingEditPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineActivationProviderSettingEditPageQuery, LineActivationProviderSettingEditPageQueryVariables>;
export const UpdateLineActivationProviderSettingDocument = gql`
    mutation UpdateLineActivationProviderSetting($input: UpdateLineActivationProviderSettingInput!) {
  updateLineActivationProviderSetting(input: $input) {
    messageApiAccessToken
    messageApiChannelSecret
    lineChannelId
    liffId
    lineFollowUrl
  }
}
    `;

/**
 * __useUpdateLineActivationProviderSettingMutation__
 *
 * To run a mutation, you first call `useUpdateLineActivationProviderSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineActivationProviderSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLineActivationProviderSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineActivationProviderSettingMutation(options: VueApolloComposable.UseMutationOptions<UpdateLineActivationProviderSettingMutation, UpdateLineActivationProviderSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateLineActivationProviderSettingMutation, UpdateLineActivationProviderSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateLineActivationProviderSettingMutation, UpdateLineActivationProviderSettingMutationVariables>(UpdateLineActivationProviderSettingDocument, options);
}
export type UpdateLineActivationProviderSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateLineActivationProviderSettingMutation, UpdateLineActivationProviderSettingMutationVariables>;